import React, { useMemo } from 'react';
import { Box, Container, H2, Grid, P, Type } from '@saladbob/sassafras';
import { PiTrophy, PiToilet } from 'react-icons/pi';

const WinnersList = ({ teams, place, color, Trophy }: {
    teams: { id: string, name: string, court: { label?: string, color?: string, textColor?: string } }[],
    place: string,
    color: string,
    Trophy: React.ReactNode,
}) => (
    <Container size="lg">
        <Box bdColor={color} bdWidth="0 0 4px">
            <H2
                font="leader"
                color="white"
                bgColor={color}
                padding={['xs', 'md']}
                width="max-content"
                rounded="md"
                margin="auto"
                mb="-24px"
            >
                {place}
            </H2>
        </Box>
        <Grid columns={{ phone: '1fr', laptop: 'max-content 1fr'}} columnGap="md" align="center" padding={['lg', 'md']}>
            <Box txtColor={color} textAlign="center">
                {Trophy}
            </Box>
            <div>
                <Grid columns={{ phone: '1fr 1fr', laptop: '1fr 1fr 1fr' }} row="max-content" height="auto">
                    {teams.map(team => (
                        <P mb="0" font="p" weight="bold" key={team.id}>
                            {team.name}
                        </P>
                    ))}
                </Grid>
            </div>
        </Grid>
    </Container>
);

const Winners = ({ tournament, bracket }) => {
    const completedData = useMemo(() => {
        if (tournament?.status === 'finished') {
            const courts = bracket?.courts;

            const teams = courts?.map(court => {
                return court.teams;
            }).flat();

            const games = courts?.map(court => {
                return court.games;
            }).flat();

            const trophies = courts?.reduce((acc, court) => {
                const ct = {
                    id: court.id,
                    label: court.label.split(' ')[1],
                    color: court.color,
                    textColor: court.textColor,
                };
                acc.firstPlace.push({
                    ...court.firstPlace,
                    court: ct,
                });
                acc.secondPlace.push({
                    ...court.secondPlace,
                    court: ct,
                });
                acc.thirdPlace.push({
                    ...court.thirdPlace,
                    court: ct,
                });
                acc.tbPlace.push({
                    ...court.tbPlace,
                    court: ct,
                });
                acc.all += 4;
                return acc;
            }, {
                firstPlace: [],
                secondPlace: [],
                thirdPlace: [],
                tbPlace: [],
                all: 0,
            });
            return {
                courts,
                teams,
                games,
                trophies,
            }
        };
        return null;
    }, [tournament, bracket]);
    return (
        <>
            <Box bgColor="white" pt="xl" mb="lg">
                <WinnersList teams={completedData.trophies.firstPlace} place="1st Place Winners" color="gold" Trophy={<PiTrophy size={180} />} />
                <WinnersList teams={completedData.trophies.secondPlace} place="2nd Place Winners" color="neutral" Trophy={<PiTrophy size={100} />} />
                <WinnersList teams={completedData.trophies.thirdPlace} place="3rd Place Winners" color="sienna" Trophy={<PiTrophy size={100} />} />
                <WinnersList teams={completedData.trophies.tbPlace} place="Toilet Bowl Champions" color="neutral200" Trophy={<PiToilet size={100} />} />
            </Box>
        </>
    );
};

export default Winners;